import RestDay from '../../model/RestDay'
import AppIcon from '../icons/AppIcon'
import PipRow from '../primitives/PipRow'
import styles from './RestDayCard.module.css'

interface RestDayCardProps {
  used: number
  total: number
  onClick: () => void
  disabled?: boolean
}

export default function RestDayCard({ used, total, onClick, disabled }: RestDayCardProps) {
  const lockHours = Math.round(RestDay.getDurationMs() / (60 * 60 * 1000))

  return (
    <button
      type="button"
      className={[styles.restcard, disabled && styles.disabled].filter(Boolean).join(' ')}
      onClick={onClick}
      disabled={disabled}
    >
      <div className={styles.icon}>
        <AppIcon icon="mdi:moon-waning-crescent" size={22} />
      </div>
      <div className={styles.text}>
        <div className={styles.heading}>
          <div className={styles.title}>Take a rest day</div>
          <PipRow total={total} used={used} />
        </div>
        <div className={styles.sub}>
          {used} of {total} used · locks logging {lockHours} hrs
        </div>
      </div>
      <AppIcon icon="mdi:chevron-right" size={20} className={styles.chevron} />
    </button>
  )
}
